import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import completeLicenseForTier1 from './completeLicenseForTier1';

const useCompleteLicenseForTier1 = (): UseMutationResult<
  undefined,
  Error,
  { businessId: string; facilityId: string; licenseNumber: string }
> =>
  useMutation<
    undefined,
    Error,
    { businessId: string; facilityId: string; licenseNumber: string }
  >({
    mutationFn: completeLicenseForTier1,
  });

export default useCompleteLicenseForTier1;
